module.exports = __webpack_public_path__ + "img/Deconnexion_Sans_Fond.eebc3e83.svg";